export default "__VITE_ASSET__D$YQrJ69__"